
import firstImage from "../../../images/decor/axis_book_shelf/1.avif"
import secondImage from "../../../images/decor/axis_book_shelf/2.avif"
import thirdImage from "../../../images/decor/axis_book_shelf/3.avif"
import mainImage from "../../../images/decor/axis_book_shelf/main.avif"

export const Axis =  {
    name:"Axis Book Shelf",
    code:'NDCON102',
    type:"Furniture",
    images:[firstImage, secondImage, thirdImage],
    main_image:mainImage,
    description:[
            "The rich, reddish tones of Redwood Pine provide a striking contrast against the industrial steel framework, creating a visually compelling and durable piece. The open shelving design of Axis not only showcases your books and décor but also maintains an airy, uncluttered look.",
            "With its minimalist lines and robust construction, Axis fits effortlessly into both residential and commercial spaces. Whether used as a statement piece or a functional storage solution, Axis elevates your environment with its blend of organic charm and contemporary style."
    ],
    information:"Introducing Axis, a contemporary bookshelf that seamlessly blends the natural beauty of Redwood Pine with the sleek sophistication of steel. Designed to be a centerpiece in any modern interior, Axis offers a harmonious balance of warmth and edge.",
}
